import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaInstagram, FaFacebook, FaTelegram } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';
import API_BASE_URL from '../config';
import SEO from './SEO';
import './Contacts.css';

const Contacts = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    
    try {
      const response = await axios.post(`${API_BASE_URL}/api/contacts/send`, {
        name: formData.name.trim(),
        email: formData.email.trim(),
        message: formData.message.trim()
      });
      
      if (response.data.success) {
        // Показываем успешное сообщение
        alert(t('contacts.sent') || 'Message sent successfully!');
    setFormData({ name: '', email: '', message: '' });
        setError(''); // Очищаем ошибки
      }
    } catch (error) {
      console.error('Error sending message:', error);
      let errorMessage = '';
      
      if (error.response) {
        // Сервер вернул ошибку
        errorMessage = error.response.data?.error || 
                      (t('contacts.error') || 'Error sending message. Please try again.');
      } else if (error.request) {
        // Запрос был отправлен, но ответа не получено
        errorMessage = t('contacts.error') || 'Connection error. Please check your internet connection and try again.';
      } else {
        // Ошибка при настройке запроса
        errorMessage = t('contacts.error') || 'Error sending message. Please try again.';
      }
      
      setError(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>
      <SEO 
        title="Contacts"
        description="Contact Sergey Levitskiy - Professional DJ and Music Producer. Book for events, weddings, and special occasions. Get in touch for collaborations."
        keywords="Sergey Levitskiy contact, DJ booking, event booking, music producer contact"
      />
      <div className="contacts-page">
      {/* Креативные эффекты фона для Contacts */}
      <div className="contacts-connections"></div>
      <div className="contacts-dots"></div>
      
      <motion.div
        className="contacts-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.h1
          className="contacts-title"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
        >
        
        </motion.h1>

        <div className="contacts-grid">
          <motion.div
            className="contacts-info"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
          >
            <h2>{t('contacts.contactInfo')}</h2>

            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div>
                <h3>{t('contacts.email')}</h3>
                <a href="mailto:booking@sergeylevitskiy.com">booking@sergeylevitskiy.com</a>
              </div>
            </div>

            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div>
                <h3>{t('contacts.phone')}</h3>
                <a href="tel:+792502305288">+7 925 023 052 88</a>
              </div>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div>
                <h3>{t('contacts.location')}</h3>
                <p>Moscow, Russia</p>
              </div>
            </div>

            <div className="social-links">
              <h3>{t('contacts.follow')}</h3>
              <div className="social-icons">
                <a href="https://www.instagram.com/levitskiy_sergey_" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://www.facebook.com/sergeylevitskiydj" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="https://t.me/sergey_levitsky" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Telegram">
                  <FaTelegram />
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="contacts-form-container"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
          >
            <h2>{t('contacts.sendMessage')}</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <input
                type="text"
                name="name"
                placeholder={t('contacts.yourName')}
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder={t('contacts.yourEmail')}
                value={formData.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder={t('contacts.yourMessage')}
                value={formData.message}
                onChange={handleChange}
                rows="6"
                required
              />
              <button type="submit" className="submit-btn" disabled={submitting}>
                <FaEnvelope /> {submitting ? (t('contacts.sending') || 'Sending...') : t('contacts.send')}
              </button>
              {error && <div className="error-message" style={{ color: '#ff4444', marginTop: '1rem', fontSize: '0.9rem' }}>{error}</div>}
            </form>
          </motion.div>
        </div>
      </motion.div>
    </div>
    </>
  );
};

export default Contacts;

